import React from "react";
import '../About.css'
import { Grid2, keyframes, Typography,Paper } from '@mui/material'
import { AboutHeroMobile } from "./AboutHeroMobile";
import { AboutInfo } from "./AboutInfo";
import { AboutVision } from "./AboutVision";

export const AboutMobile = () => {
  return (
    <Grid2 container width="100% !important"  justifyContent="center" >
      {/* <AboutHeroMobile/> */}
      
      <Grid2 className="info" container justifyContent="center" alignItems="flex-start" gap="10px">  
        <Typography className="headingdata" fontSize="20px !important" textAlign="center" >About us</Typography>
        <AboutInfo/>
      </Grid2>

      <AboutVision/>

      <Grid2 className="info" container justifyContent="center" sx={{width:"100%",position:"relative",gap:"20px"}}>
        <Typography className="headingdata">What we do ?</Typography>
        <Grid2 width="90%" sx={{padding:"10px",margin:"10px 0px "}} >
          <Typography className="contentData" >"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dicta, ratione sint. Similique mollitia facere perspiciatis, repellat placeat corporis ex earum quia excepturi! Neque alias qui eveniet veritatis doloribus earum quia! Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit quibusdam sequi nihil est quaerat placeat officiis nam officia, exercitationem rem ex esse quo eum corrupti nobis fugiat laudantium aliquid quam."</Typography>
        </Grid2>
      </Grid2>

      <Grid2 className="info" container justifyContent="center" sx={{width:"100%",position:"relative",gap:"20px"}}>
        <Typography className="headingdata">What we are?</Typography>
        <Grid2 width="90%" sx={{padding:"10px",margin:"10px 0px "}} >
           <Typography className="contentData">"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dicta, ratione sint. Similique mollitia facere perspiciatis, repellat placeat corporis ex earum quia excepturi! Neque alias qui eveniet veritatis doloribus earum quia! Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit quibusdam sequi nihil est quaerat placeat officiis nam officia, exercitationem rem ex esse quo eum corrupti nobis fugiat laudantium aliquid quam."</Typography>
        </Grid2>
      </Grid2>

    </Grid2>
  );
};

 